<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
      <b-modal 
          v-model="showUploader"  
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
            <galerie-manager :__payload="dataUploaderPayload"></galerie-manager>
          </b-modal>

      <div class="editionPanel">
        <div class="row">
          <div class="col-lg-3 mediaColumn">
            <div class="mediaPanel">
              <div class="mediaPreview" @click="showUploader = true">
                <img :src="societeLogoSrc" alt="Client" class="previewImage" />
              </div>

              <b-button class="mediaButton" @click="showUploader = true" size="sm">
                {{ hasSocieteLogo ? 'Changer logo' : 'Ajouter logo' }}
              </b-button>

              <div class="mediaHint">Logo ou visuel principal du client.</div>
            </div>
          </div>

          <div class="col-lg-9 fieldsColumn">
            <div class="row">
              <div class="col-md-12 formGroup">
                <label class="formLabel">Société</label>
                <base-input
                  placeholder="Société"
                  v-model="__item.name"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Téléphone</label>
                <base-input
                  placeholder="Téléphone"
                  v-model="__item.tel"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Fax</label>
                <base-input
                  placeholder="Fax"
                  v-model="__item.fax"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Email</label>
                <base-input
                  placeholder="Email"
                  v-model="__item.email"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Matricule fiscal</label>
                <base-input
                  placeholder="Matricule Fiscal"
                  v-model="__item.mf"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">NRC</label>
                <base-input
                  placeholder="NRC"
                  v-model="__item.nrc"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">CD</label>
                <base-input
                  placeholder="CD"
                  v-model="__item.cd"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Ville</label>
                <div class="selectorField">
                  <selector
                    _id="67786b6ee4f5b22e0ae23681"
                    :_parentItem="__item"
                    _warpper="ville"
                    :_showTitle="false"
                    _customCss="background-color:#F8FAFC; padding: 10px; border-radius: 12px; margin-bottom: 0;"
                  ></selector>
                </div>
              </div>

              <div class="col-md-8 formGroup">
                <label class="formLabel">Adresse</label>
                <base-input
                  placeholder="Adresse"
                  v-model="__item.adress"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Banque</label>
                <div class="selectorField">
                  <selector
                    _id="67786b85e4f5b22e0ae23683"
                    :_parentItem="__item"
                    _warpper="banque"
                    :_showTitle="false"
                    _customCss="background-color:#F8FAFC; padding: 10px; border-radius: 12px; margin-bottom: 0;"
                  ></selector>
                </div>
              </div>

              <div class="col-md-8 formGroup">
                <label class="formLabel">RIB</label>
                <base-input
                  placeholder="RIB"
                  v-model="__item.rib"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>
            </div>

            <div class="summaryCard">
              <div class="summaryHeader">Résumé client</div>
              <div class="summaryBody">
                <div class="summaryMedia">
                  <img :src="societeLogoSrc" alt="Client" class="summaryImage" />
                </div>
                <div class="summaryInfo">
                  <div><b>Société :</b> {{ __item.name || '-' }}</div>
                  <div><b>Ville :</b> {{ __item.ville || '-' }}</div>
                  <div><b>Adresse :</b> {{ __item.adress || '-' }}</div>
                </div>
                <div class="summaryInfo">
                  <div><b>Téléphone :</b> {{ __item.tel || '-' }}</div>
                  <div><b>Email :</b> {{ __item.email || '-' }}</div>
                  <div><b>Banque :</b> {{ __item.banque || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actionBar">
          <div class="col-md-12">
            <b-button size="sm" variant="danger"  @click="dispatchCancel()"> Fermer </b-button>
            <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>


export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },

    __isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __onSelect: {
      type: Function,
      default: () => {
        () => {};
      },
    },
  },
  data: () => {
    return {
      _packID: [],
      fullList: [],
      showUploader: false,
      dataUploaderPayload: {
        folder: "prods",
        onFireCB: () => {},
        multiSelection: false,
        customClass: "customCatEditModal"
      },
      errorCtrl: [],
    }
  },
  computed: {
    societeLogoSrc() {
      return this.getTof(this.__item.logo);
    },
    hasSocieteLogo() {
      return !!this.__item.logo;
    },
  },
  methods: {

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/societes/No-Image.jpg');
      // return 'http://localhost:5000/uploads/'+c.split("/uploads/")[1];
      // return './uploads/'+c.split("/uploads/")[1];
    },

    dispatchSave() {
      if(this.$props.__isLightMode) {
        this.$props.__onSelect(this.$props.__item)
      }
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },


   

  },
  mounted() {
    
    this.dataUploaderPayload.clientID = '665d03b586d558945dfffa28';
    this.dataUploaderPayload.onFireCB = (params) => {
      this.showUploader = false
        this.__item.logo = params[0];
    }
  },

  watch: {
    
  },


};
</script>
<style scoped>
.editionPanel {
    width: 100% !important;
    padding: 20px;
    margin-bottom: 0;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}
.mediaColumn,
.fieldsColumn {
  margin-bottom: 12px;
}
.mediaPanel {
  height: 100%;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #dbe4f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mediaPreview {
  min-height: 210px;
  border-radius: 14px;
  border: 1px dashed #cbd5e1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}
.previewImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mediaButton {
  background: #1f2a44;
  border-color: #1f2a44;
  color: #fff;
  font-weight: 600;
}
.mediaButton:hover,
.mediaButton:focus {
  background: #2f436d;
  border-color: #2f436d;
}
.mediaHint {
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}
.formGroup {
  margin-bottom: 12px;
}
.formLabel {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.selectorField {
  width: 100%;
}
.summaryCard {
  margin-top: 6px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #dbe4f0;
}
.summaryHeader {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.summaryBody {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
}
.summaryMedia {
  width: 68px;
  height: 68px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dbe4f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.summaryImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.summaryInfo {
  flex: 1 1 200px;
  font-size: 13px;
  color: #334155;
}
.summaryInfo div + div {
  margin-top: 4px;
}
.actionBar {
  margin-top: 12px;
  text-align: right;
}
.actionBar .btn + .btn {
  margin-left: 8px;
}
:deep(.modal-xl) {
  max-width: 85% !important;
}
.form-control option {
  color: black;
}
@media (max-width: 991px) {
  .editionPanel {
    padding: 16px;
  }
  .mediaPreview {
    min-height: 160px;
  }
  .summaryBody {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

